import { render, staticRenderFns } from "./risk-definition-applied-control-view.vue?vue&type=template&id=25d66834"
import script from "./risk-definition-applied-control-view.vue?vue&type=script&lang=js"
export * from "./risk-definition-applied-control-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports